import { render } from "./project-report-table.vue?vue&type=template&id=293be53e"
import script from "./project-report-table.vue?vue&type=script&lang=js"
export * from "./project-report-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__